var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "empty" }, [
    _vm._v(_vm._s(_vm.$t("pc_biz_lbl_nodata" /** 暂无数据 */))),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }